import { useState, useEffect } from 'react';
import fetchers from '../functions/fetch';
import { post } from '../mocks/postsMocks/postsStore';

const usePosts: () => post[] = () => {
  const [posts, setPosts] = useState<post[]>([]);
  useEffect(() => {
    fetchers.get_posts({}).then((res) => {
      if (res.status === 200) {
        setPosts(res.data.posts);
      }
    });
  }, []);
  return posts;
};

export default usePosts;
